import { api } from "./client";
import type { DashboardSummaryOut } from "@/types/api";

export function getDashboardSummary(flightId?: number | null) {
  const suffix =
    flightId != null ? `?flight_id=${encodeURIComponent(flightId)}` : "";
  return api.get<DashboardSummaryOut>(`/api/dashboard/summary${suffix}`);
}
